<template>
    <div class="cz2__details-header">
        <h1 class="cz2__type__header cz2__product-title">{{productTitle}}</h1>
        <div class="cz2__type__normal cz2__type__no-wrap cz2__product-price">
            {{subtotalUnitPrice}}
            <span v-if="isDiscounted" class="cz2__product-price--discounted">{{defaultUnitPrice}}</span>
            <span class="cz2__type__small cz2__price-each">{{$t('PRICE_EACH')}}</span>
        </div>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__product-title {
            width: 100%;

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;

            @include respond-above(sm) {
                margin-bottom: 10px;

                // Long names should wrap.
                white-space: normal;
            }
        }

        .cz2__product-price--discounted {
            color: #63666a;
            text-decoration: line-through;
            padding-right: 6px;
            padding-left: 2px;
        }

        .cz2__price-each {
            color: #63666a;
        }

        .cz2__details-header {
            @include respond-below(sm) {
                display: flex;

                > * {
                    white-space: nowrap;
                }

                .cz2__product-title {
                    flex: 1 0 auto;
                    width: 1px;
                }

                .cz2__product-price {
                    position: relative;
                    top: 2px;
                }
            }
        }
    }
</style>

<script>
    export default {
        computed: {
            /**
             * Current view controller.
             */
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            /**
             * Product title.
             */
            productTitle() {
                if (this.viewController && this.viewController.blueprint) {
                    return this.viewController.blueprint.name;
                }

                return '';
            },

            /**
             * Subtotal unit price.
             */
            defaultUnitPrice() {
                return this.$store.state.customizer.defaultUnitPrice;
            },

            /**
             * Subtotal unit price.
             */
            subtotalUnitPrice() {
                return this.$store.state.customizer.subtotalUnitPrice;
            },

            /**
             * Return if the default unit price does not equal the current unit price.
             * Uses string comparison for formatted values
             */
            isDiscounted() {
                return this.subtotalUnitPrice !== this.defaultUnitPrice;
            },
        },
    };
</script>
